<template>
    <v-card>
      <v-toolbar color="primary" dark flat class="pa-2">
        <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
      </v-toolbar>
      <v-form id="createForm" @keyup.enter.native="onSave">
        <v-layout row wrap>
          <v-flex xs12 v-for="item in inputItems" style="padding: 10px">
            <c-textbox :type="item.type" :icon="item.icon" :validate="item.validate" :label="$t(item.label)"
                       :id="item.id" :name="item.name" :value="values[item.name]"
                       v-model.trim="values[item.name]"
                       v-validate="'required'"
                       :placeholder="$t(item.placeHolder)" :max-length="item.maxlength" ref="input"
                       :error-messages="errors.first('{{item.name}}')"
            ></c-textbox>
          </v-flex>
        </v-layout>
      </v-form>
      <div style="text-align: right">
        <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" dark @click="onSave"><v-icon dark left>save</v-icon>{{$t('lang.common.save')}}</v-btn>
        <v-btn color="error" dark @click="onCancel"><v-icon dark left>cancel</v-icon>{{$t('lang.common.cancel')}}</v-btn>
      </div>
    </v-card>
</template>

<script>
  import formStyle from "../../../../public/plugin/form/form.css"
  import datePickerStyle from "../../../../public/css/bootstrap-datepicker.css"
  import CTextbox from "../../../components/form/Textbox";
  import Validator from "../../../../public/js/validator";
  import FormGenerator from "../../../../public/plugin/form/form";
  import axios from "axios/index";
  import {message} from "@/shared/message";
  import ISelectbox from "../../../components/form/SelectBox";
  //const $ = require("jquery");


  const v = Validator();
  ////console.log("---v---");
  ////console.log(v);

  export default {
    name: 'dept-edit',
    components: {ISelectbox, CTextbox, Validator},
    inheritAttrs: true,
    props: {
      formName: {
        type: String,
        default: 'Manager'
      },
      inputItems: {
        type: Array,
        default: () => []
      },
      createUrl: {
        type: String,
        default: ""
      },
      column: {
        type: String,
        default: "12"
      },
      defaultData: {
        type: Object,
        default: ()=>{}
      }
    },
    data: () => {
      return {
        values: {}
      }
    },
    watch: {
      defaultData: function (value) {
        ////console.log("watch default data");
        this.values = value;
        let formConfig = value["formConfig"];//FormGenerator.decodeHTML(value["formConfig"]);
        //console.log(formConfig);
        //console.log(FormGenerator);
        FormGenerator.loadDesign(formConfig);
      }
    },
    mounted(){
      axios.get("plugin/form/form.json").then(data=>{
        //console.log("---config---");
        //console.log(data);
        FormGenerator.inputConfig = data;
        FormGenerator.createInputPanel();
      }, error =>{
        alert("Can't get form config");
      });
    },
    methods: {
      onSave: function () {
        let validate = v.validate(this);
        this.values["formConfig"] = FormGenerator.exportToString();
        if(this.values["formConfig"] == "error"){
          return;
        }
        //this.$validator.validate().then(valid=>{alert("Oke")});
        if (validate) {
          axios.post(process.env.VUE_APP_API_URL+this.createUrl, this.values).then(data => {
            if(data.success) {
              if(this.values["formId"] != undefined) {
                message.success(this.$t("lang.common.update_success"));
              } else {
                message.success(this.$t("lang.common.save_success"));
              }
              this.onCancel();
            } else {
              message.error(data.description);
            }
          }, error => {
            message.error(error);
          });
        } else {
          message.error(this.$t("lang.common.validate_fail"));
        }
      },

      onView: function(value){
        this.values = value;
        let formConfig = value["formConfig"];//FormGenerator.decodeHTML(value["formConfig"]);
        ////console.log(formConfig);
        ////console.log(FormGenerator);
        FormGenerator.loadDesign(formConfig);
        this.$refs.input[0].focus();
      },

      onCancel: function () {
        this.values = {};
        document.getElementById("searchDiv").style.display = "";
        document.getElementById("createDiv").style.display = "none";
        this.$parent.search();
      }
    }


  }
</script>
